import layout from './ODataTokenGeneratorView.html?raw';
import View from '@/Views/View';
import ComponentManager from '@/Management/ComponentManager';
import ODataTokenGeneratorViewModel from '@/Components/OData/ODataTokenGeneratorViewModel';

export default class ODataTokenGeneratorView extends View {
    private view: JQuery<HTMLElement>;

    public constructor(private viewModel: ODataTokenGeneratorViewModel, private element?: JQuery<HTMLElement>) {
        super();
    }

    public getView(): JQuery<HTMLElement> {
        if (this.view != null) {
            return this.view;
        }
        
        this.view = this.applyBindings(this.element, this.viewModel, layout);

        return this.view;
    }
}

ComponentManager.setView('ODataTokenGenerator', ODataTokenGeneratorView, 'RADPresentation.HTMLClient.DefaultViewExtensions');